import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PortalService } from '../portal.service';

@Component({
  selector: 'app-tela-principal',
  templateUrl: './tela-principal.component.html',
  styleUrls: ['./tela-principal.component.scss']
})
export class TelaPrincipalComponent implements OnInit {

  public numeroDeSerie;

  constructor(private route: ActivatedRoute, private service: PortalService) { }

  ngOnInit() {

    this.route.params.subscribe(params => {
      this.numeroDeSerie = params['numeroDeSerie'];
      this.service.setNumeroDeSerie(this.numeroDeSerie);

      window.location.href = "#/boleto";
    });
  }
}



// WEBPACK FOOTER //
// C:/Disco D/Projetos/central-cliente/src/app/area-cliente/portal/tela-principal/tela-principal.component.ts